import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable } from 'mana-syringe';
import { HookHub } from '@antv/xflow-hook';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowEdgeCommands, XFlowNodeCommands } from '../constant';
import { Disposable } from '../../common/disposable';
export var NsDelNode;
(function (NsDelNode) {
    /** Command: 用于注册named factory */
    NsDelNode.command = XFlowNodeCommands.DEL_NODE;
    /** hook name */
    NsDelNode.hookKey = 'delNode';
    /** 创建 hook */
    NsDelNode.createHook = () => {
        return new HookHub();
    };
})(NsDelNode || (NsDelNode = {}));
let DelNodeCommand = 
/** 创建节点命令 */
class DelNodeCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            const result = yield hooks.delNode.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { commandService, deleteNodeService, options } = handlerArgs;
                const graph = yield ctx.getX6Graph();
                if (deleteNodeService) {
                    const canDel = yield deleteNodeService(handlerArgs);
                    if (!canDel)
                        return { err: ' service rejected' };
                }
                const nodeId = (handlerArgs.x6Node || handlerArgs.nodeConfig).id;
                const nodeCell = graph.getCellById(nodeId);
                if (nodeCell && nodeCell.isNode()) {
                    /** 先清理连线 */
                    const edges = [
                        ...(graph.getIncomingEdges(nodeCell) || []),
                        ...(graph.getOutgoingEdges(nodeCell) || []),
                    ];
                    yield Promise.all(edges.map(edge => {
                        return commandService.executeCommand(XFlowEdgeCommands.DEL_EDGE.id, {
                            x6Edge: edge,
                        });
                    }));
                    /** 再清理节点 */
                    const nodeConfig = nodeCell.getData();
                    nodeCell.remove(Object.assign(Object.assign({}, options), { isCommand: true }));
                    /** add undo: delete node */
                    ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                        yield commandService.executeCommand(XFlowNodeCommands.ADD_NODE.id, {
                            nodeConfig,
                        });
                        // TODO: 支持线和节点的undo
                        // 通过 sequence mapping 出新的port id
                        // const nodeCtx = nodeCmd.contextProvider()
                        // const { nodeCell } = nodeCtx.getResult()
                        // edgeCmds.forEach(async cmd => {
                        //   const c = cmd.contextProvider()
                        //   const { edgeConfig } = c.getResult()
                        // })
                    })));
                    return { err: null, nodeConfig };
                }
                return { err: 'node is not exist' };
            }), runtimeHook);
            ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            if (this.isUndoable()) {
                const ctx = this.contextProvider();
                ctx.undo();
            }
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable()) {
                yield this.execute();
            }
            return this;
        });
    }
    isUndoable() {
        const ctx = this.contextProvider();
        return ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], DelNodeCommand.prototype, "contextProvider", void 0);
DelNodeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsDelNode.command.id },
    })
    /** 创建节点命令 */
], DelNodeCommand);
export { DelNodeCommand };
//# sourceMappingURL=node-del.js.map